export const formatNumberWithCommas = (number: number) =>
  number.toLocaleString();
